import React from 'react';
import Stack from 'react-bootstrap/Stack';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

function LaunchSelectionContent({ selectionMade }) {
  return (
    <Stack className="w-100 p-4 d-flex justify-content-center">
      <Container className="w-25 h-100">
        <Row className="mb-4">
          <Col>
            <Button variant="primary" className="w-100" onClick={() => selectionMade('individual')}>
              Launch Individual Assessment
            </Button>
          </Col>
        </Row>
        <Row>
          <Col>
            <Button variant="primary" className="w-100" onClick={() => selectionMade('csv')}>
              Upload and Launch Multiple Assessments
            </Button>
          </Col>
        </Row>
      </Container>
    </Stack>
  );
}

export default LaunchSelectionContent;
